import React from "react";
import {Card} from 'react-bootstrap';

function STCCardHeader(props){

    return(
        <Card.Header
            className={props.className}
            style={props.style}
            onClick={props.onClick}
            onDoubleClick={props.onDoubleClick}

            as={props.as}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card.Header>
    )

}
export default STCCardHeader;